export default __webpack_public_path__ + "static/media/header-back.c1a3d07a.jpg";